export default "__VITE_ASSET__BOckTpRQ__"